import { FC, useMemo } from 'react'

import { DateCard } from '@/compositions'
import { ShiftExchangeStatus } from '@/models'
import { getShiftExchangeStatus } from '@/services/ShiftExchangeService/getShiftExchangeStatus'

import './ExchangeHeader.scss'
import './ExchangeHeader.scss'

interface ExchangeHeaderProps {
    date: Date
    status?: ShiftExchangeStatus
    className?: string
}

export const ExchangeHeader: FC<ExchangeHeaderProps> = ({
    date,
    status = ShiftExchangeStatus.open,
    className = '',
}) => {
    const { color } = useMemo(() => getShiftExchangeStatus(status), [status])

    return (
        <DateCard
            color={color}
            date={date}
            className={`exchange-header ${className}`}
        />
    )
}
